import { RoleName } from '@/types/application-role-name';

export const roleNames: Record<string, RoleName> = {
  platformAdmin: 'Platform Admin',
  organisationAdmin: 'Organisation Admin',
  organisationTechnician: 'Organisation Technician',
};
